module.exports = __webpack_public_path__ + "img/4.424297e3.png";